export enum DictionaryCode {
  ApplicationTimes = 'application-times',
  AreaOfInjection = 'area-of-injection',
  BeautyRoutines = 'beauty-routines',
  Common = 'common',
  CommonFillers = 'common-fillers',
  Durations = 'durations',
  ExtrusionForces = 'extrusion-forces',
  HaConcentrations = 'ha-concentrations',
  Icons = 'icons',
  Ingredients = 'ingredients',
  InjectionPlaces = 'injection-places',
  InjectionTools = 'injection-tools',
  LegalMentions = 'legal-mentions',
  Titles = 'titles',
  TreatmentEssentials = 'treatment-essentials',
  Volumes = 'volumes',
}

export enum DictionaryTitlesCode {
  Volume = 'volume',
  KeyActiveIngredients = 'key-active-ingredients',
  Application = 'application',
  BeautyTip = 'beauty-tip',
  HaConcentration = 'ha-concentration',
  Contains = 'contains',
  AreaOfInjection = 'area-of-injection',
  WhatIsNboost = 'what-is-nboost',
  KeyBenefits = 'key-beneftis',
  ProductFeatures = 'product-features',
  Sct = 'sct',
  FillersCrossSellingTitle = 'fillers-cross-selling-title',
  Duration = 'duration',
  ExtrusionForce = 'extrusion-force',
  Stiffness = 'stiffness',
  HowItWorks = 'how-it-works',
  Results = 'results',
  TechnicalFeatures = 'technical-features',
  DevicesCrossSellingTitle = 'devices-cross-selling-title',
  AestheticIndications = 'aesthetic-indications',
  ScienceBehind = 'science-behind',
  RoutineBanner = 'routine-banner',
  CosmeceuticalsCrossSellingTitle = 'cosmeceuticals-cross-selling-title',
  IngredientsList = 'ingredients-list',
  InjectionPlace = 'injection-place',
  InjectionTool = 'injection-recommended-with',
  Downloads = 'downloads',
  DownloadsSubtitle = 'downloads-subtitle',
}

export interface DictionariesSearchParams {
  limit?: number;
  offset?: number;
  page?: number;
}

export interface BaseDictionaryDTO {
  code: DictionaryCode;
  description: string;
}

export interface DictionaryListDTO {
  data: BaseDictionaryDTO[];
  meta: {
    total: number;
  };
}

export interface DictionaryEntryDTO {
  code: string;
  translations: {
    value: string;
    languages_code: string;
  }[];
}

export interface DictionaryDTO {
  code: DictionaryCode;
  description: string;
  entries: DictionaryEntryDTO[];
}
